import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet'; // Added for SEO
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';

function AllRequests() {
  const [categoryRequests, setCategoryRequests] = useState([]);

  useEffect(() => {
    fetchCategoryRequests();
  }, []);

  const fetchCategoryRequests = async () => {
    try {
      const res = await axios.get('/api/requests/by-category');
      console.log('Fetched category requests:', res.data);
      setCategoryRequests(res.data);
    } catch (error) {
      console.error('Error fetching category requests:', error.response ? error.response.data : error.message);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <Helmet>
        <title>Fixxzap - All Past Service Requests</title>
        <meta name="description" content="Browse all past service requests on Fixxzap. Find local providers for plumbing, electrical, and more." />
        <meta name="keywords" content="past service requests, local services, Fixxzap" />
        <meta property="og:title" content="Fixxzap - All Past Service Requests" />
        <meta property="og:description" content="Browse all past service requests on Fixxzap." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://fixxzap.com/all-requests" />
        <meta property="og:image" content="https://fixxzap.com/logo.jpg" /> {/* Update with actual image URL */}
        <link rel="canonical" href="https://fixxzap.com/all-requests" />
      </Helmet>
      {/* Google Ad Banner Placeholder */}
      <div className="ad-placeholder mb-4 text-center" style={{ backgroundColor: '#e2e8f0', height: '90px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px' }}>
        <p className="text-muted">Google Ad Banner (728x90)</p>
      </div>
      <h1 className="text-center mb-4">All Past Service Requests</h1>
      <div className="row">
        <div className="col-12">
          <div className="accordion" id="categoryAccordion">
            {categoryRequests.map((category, index) => (
              <div className="accordion-item" key={index}>
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded={index === 0 ? "true" : "false"}
                    aria-controls={`collapse${index}`}
                  >
                    {category._id}
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#categoryAccordion"
                >
                  <div className="accordion-body">
                    {category.requests.map(req => (
                      <div className="card mb-3" key={req._id}>
                        <div className="card-body">
                          <h5 className="card-title">{req.serviceCategory} in {req.city}</h5>
                          <p className="card-text">{req.scope}</p>
                          <small className="text-muted">Posted: {new Date(req.createdAt).toLocaleDateString()}</small>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 mx-auto">
          {/* Google Ad Sidebar Placeholder */}
          <div className="ad-placeholder mb-4" style={{ backgroundColor: '#e2e8f0', height: '250px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px' }}>
            <p className="text-muted">Google Ad (250x250)</p>
          </div>
        </div>
      </div>
      {/* Floating Back Link */}
      <a href="/" className="btn btn-primary floating-back-link">Back to Service Requests</a>
    </div>
  );
}

export default AllRequests;
